import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { defaultConfig, defaultTheme } from './constants';
import './index.css';
import { VovSystemApp } from './vov-system-widget';
import VovSystemHomepage from './components/vov-system-homepage';
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(_jsx(React.StrictMode, { children: _jsx(BrowserRouter, { children: _jsx(Routes, { children: _jsx(Route, { path: '/', element: _jsx(VovSystemApp, { config: defaultConfig, theme: defaultTheme, children: _jsx(VovSystemHomepage, {}) }) }) }) }) }));
